module.exports = __webpack_public_path__ + "static/img/Lxzk3000.a03892cd.png";